module.exports = __webpack_public_path__ + "img/FPT06.aaf836b4.svg";